import React, { useState } from "react";
import { useTranslation } from "react-i18next";

// Carte blanche arrondie, l'unité visuelle de base du Studio.
export function Card({ children, className = "" }) {
  return (
    <div className={`bg-white rounded-2xl border border-gray-100 shadow-sm p-6 ${className}`}>
      {children}
    </div>
  );
}

// Champ en lecture seule avec bouton "Copier" (host, port, mount, mot de passe…).
export function CopyField({ label, value, highlight = false }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const copy = () => {
    if (!value) return;
    navigator.clipboard.writeText(String(value)).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    });
  };
  return (
    <div className={`rounded-xl border p-4 ${highlight ? "border-amber-200 bg-amber-50" : "border-gray-100"}`}>
      <p className="text-gray-500 text-sm">{label}</p>
      <div className="flex items-center gap-2 mt-1">
        <code className="text-sm text-gray-800 break-all flex-1">{value || "—"}</code>
        <button
          onClick={copy}
          disabled={!value}
          className="text-xs bg-white border border-gray-200 hover:bg-gray-100 px-2 py-1 rounded disabled:opacity-50 whitespace-nowrap"
        >
          {copied ? t("studio.actions.copied") : t("studio.actions.copy")}
        </button>
      </div>
    </div>
  );
}

// État vide illustré.
export function EmptyState({ icon = "📭", title, hint }) {
  return (
    <div className="text-center py-10">
      <div className="text-4xl mb-3">{icon}</div>
      <p className="text-gray-700 font-medium">{title}</p>
      {hint && <p className="text-sm text-gray-500 mt-1">{hint}</p>}
    </div>
  );
}

// Carte "fonctionnalité verrouillée" → invite à améliorer le plan.
export function UpgradeCard({ title, desc }) {
  const { t } = useTranslation();
  return (
    <Card className="text-center">
      <div className="text-4xl mb-3">🔒</div>
      <h3 className="font-semibold text-gray-900 text-lg">{title}</h3>
      <p className="text-gray-500 mt-2 max-w-md mx-auto">{desc}</p>
      <a
        href="/#pricing"
        className="inline-block mt-5 bg-purple-600 hover:bg-purple-700 text-white px-5 py-2.5 rounded-xl font-medium"
      >
        {t("studio.locked.upgrade")}
      </a>
    </Card>
  );
}

// Petit bouton d'action réutilisable.
export function TabHeading({ title, subtitle, action }) {
  return (
    <div className="flex items-start justify-between gap-3 flex-wrap mb-5">
      <div>
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
        {subtitle && <p className="text-sm text-gray-500 mt-0.5 max-w-xl">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
